import { FC, useEffect, useMemo } from 'react';
import Card from 'components/UI/Card';
import {
  configSelector,
  fetchSubscriptions,
} from 'store/husqiotbusState/husqiotbusState';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { HusqiotbusConfig } from 'models/husqiotbus';
import Loader from 'components/UI/Loader';
import Heading, { Type as HeadingType } from 'components/UI/Heading';
import { FormattedMessage } from 'react-intl';
import SubscriptioTable from '../SubscriptionTable';

type SubscriptionCardProps = {
  title: string;
};

const SubscriptionCard: FC<SubscriptionCardProps> = ({ title }) => {
  const dispatch = useAppDispatch();
  const { subscriptions }: HusqiotbusConfig = useAppSelector(configSelector);
  const { data, isLoading, error } = subscriptions;

  useEffect(() => {
    dispatch(fetchSubscriptions());
  }, [dispatch]);

  const subs = useMemo(() => {
    if (isLoading) {
      return <Loader center />;
    }
    if (error) {
      return <Heading type={HeadingType.h4}>{error.title}</Heading>;
    }
    if (!data || data?.length === 0) {
      return null;
    }

    return (
      <div className="subscriptions">
        <SubscriptioTable subscriptions={data}></SubscriptioTable>
      </div>
    );
  }, [error, isLoading, data]);

  return (
    <Card>
      <Heading type={HeadingType.h3} uppercase>
        <FormattedMessage id={title} />
      </Heading>
      {subs}
    </Card>
  );
};

export default SubscriptionCard;
